const NOTCH_MASK_ID = "bottom-nav-wisdom-ai-notch-mask";
const NOTCH_CUTOUT_PATH = "M -51.85 -1 L -51.85 0 A 18 18 0 0 1 -33.9 19.38 A 34 34 0 1 0 33.9 19.38 A 18 18 0 0 1 51.85 0 L 51.85 -1 Z";

export const BottomNavWisdomAINotchBackground = () => (
  <svg aria-hidden="true" focusable="false" className="absolute inset-0 w-full h-full z-[-1] drop-shadow-[0_-2px_6px_rgba(0,0,0,0.15)]">
    <defs>
      <mask id={NOTCH_MASK_ID}>
        <rect width="100%" height="100%" fill="white" />
        <svg x="50%" overflow="visible">
          <path d={NOTCH_CUTOUT_PATH} fill="black" />
        </svg>
      </mask>
    </defs>
    <rect width="100%" height="200%" rx="24" fill="white" mask={`url(#${NOTCH_MASK_ID})`} />
  </svg>
);
